import { useMutation } from '@tanstack/react-query'
import { useToast } from 'src/shared/hooks/use-toast'

import { ServerRoutes } from './serverRoutes'

interface GenerateInvitationLinkProps {
  emails: string
  organization_id: string
}

export const useGenerateInvitationLink = () => {
  const toast = useToast()

  return useMutation({
    mutationFn: async (props: GenerateInvitationLinkProps) => {
      const response = await fetch(
        import.meta.env.VITE_BE_SERVER_URL +
          ServerRoutes.generateInvitationLink,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            emails: props.emails,
            organization_id: props.organization_id,
          }),
        }
      )

      if (!response.ok) {
        const errorData = (await response.json().catch(() => null)) as {
          msg?: string
        } | null
        throw new Error(errorData?.msg || 'Failed to generate invitation link')
      }
    },
    onSuccess: () => {
      toast.toast({
        title: 'Invite sent',
        variant: 'success',
        duration: 5000,
      })
    },
    onError: (error: Error) => {
      toast.toast({
        title: 'Something went wrong',
        description: error.message,
        variant: 'destructive',
        duration: 5000,
      })
    },
  })
}
